
import { Component, Vue } from "vue-property-decorator"
import { State, Getter } from "vuex-class"

import ZendeskHelp from "@/components/ZendeskHelp.vue"

import { BaseState } from "@/store"
import { CurrentUser } from "@/types/user"

@Component({
	components: {
		"zendesk-help": ZendeskHelp
	}
})
export default class SideBar extends Vue {
	@State((state: BaseState) => state.me) private readonly me!: CurrentUser;

	@Getter("getRecordName") private readonly recordName!: string;
	@Getter("getHasIntegrations") private readonly hasIntegrations!: boolean;

	// This will trigger before the router-link
	private logoClicked (): void {
		// When we're on the dashboard navigate away so that the router-link will take us back to the dashboard and load the default dash
		if (this.$router.currentRoute.name === "dashboard") {
			this.$router.push({ name: "/" })
		}
	}
}
